/**
 * @generated SignedSource<<7089c5960ff9218df96767657477a339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RespondForm_form$data = {
  readonly id: string;
  readonly isClosed: boolean;
  readonly questions: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RespondQuestionCard_formQuestion">;
  }>;
  readonly " $fragmentType": "RespondForm_form";
};
export type RespondForm_form$key = {
  readonly " $data"?: RespondForm_form$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondForm_form">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondForm_form",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isClosed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormQuestion",
      "kind": "LinkedField",
      "name": "questions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RespondQuestionCard_formQuestion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Form",
  "abstractKey": null
};
})();

(node as any).hash = "55ee832e60a3e56881b84958e4d41dd6";

export default node;
